import React, { useState, useEffect } from "react";
import { IconEye, IconEdit, IconDelete } from "../../assets/icons/Icon";
import {
  StyledCard,
  InnerBox,
  CardTitle,
  TagsFlex,
  Tag,
  TagNumber,
  ButtonsBox,
  CardButton,
} from "./ProjectCard.styles";

interface CardProps<T> {
  item: T;
  title?: string;
  header?: string;
  licenses?: string;
  activeLicenses?: string;
  onView?: (item: T) => void;
  onEdit?: (item: T) => void;
  onDelete?: (item: T) => void;
}

const ProjectCard = <T extends Record<string, any>>({
  item,
  title,
  header,
  licenses,
  activeLicenses,
  onView,
  onEdit,
  onDelete,
}: CardProps<T>) => {
  return (
    <StyledCard onDoubleClick={() => onView?.(item)}>
      <InnerBox onClick={() => onView?.(item)}>
        <CardTitle>{title}</CardTitle>
        id: {header}
        <TagsFlex>
          <Tag>
            <TagNumber>{licenses}</TagNumber>
            Количество лицензий
          </Tag>
          <Tag>
            <TagNumber>{activeLicenses}</TagNumber>
            Активные лицензии
          </Tag>
        </TagsFlex>
      </InnerBox>

      <ButtonsBox>
        <CardButton onClick={() => onView?.(item)}>
          <IconEye size={16} />
        </CardButton>
        <CardButton onClick={() => onEdit?.(item)}>
          <IconEdit size={16} />
        </CardButton>
        <CardButton onClick={() => onDelete?.(item)}>
          <IconDelete size={16} />
        </CardButton>
      </ButtonsBox>
    </StyledCard>
  );
};

export default ProjectCard;
